export enum SayingTicketsTypes
{
    NoSound = 1,
    SimpleSound = 2,
    Loudly = 3
}